import React from "react";
import {Route} from "react-router-dom";
import DashboardPage from "./pages/DashboardPage";
import ExplorePage from "./pages/ExplorePage";
import AdminPage from "./pages/AdminPage";
import ReportsPage from "./pages/ReportsPage";
import StartPage from "./pages/StartPage";
import SystemPage from "./pages/SystemPage";
import RoutingPage from "./pages/RoutingPage";
import UserEditorPage from "./pages/UserEditorPage";
import RoleEditorPage from "./pages/RoleEditorPage";
import TriggerEditorPage from "./pages/TriggerEditorPage";
import FlkPage from "./pages/FlkPage";
import CardsPage from "./pages/CardsPage";
import LoginPage from "./pages/LoginPage";
import {HomeOutlined} from "@ant-design/icons";
import {Breadcrumb} from "antd";
import WdAdminPage from "./pages/WdAdminPage";
import NsiPage from "./pages/NsiPage";
import NsisPage from "./pages/NsisPage";
import DemoPage from "./pages/DemoPage";
import {modelName} from "./Modeling/registry";

// const CustomBreadcrumb = (config) => ({}) => <Breadcrumb.Items href={"/"}> <HomeOutlined />Главная</Breadcrumb.Items>
// <Breadcrumb.Item href={match.url} key={match.url}> <HomeOutlined />Главная</Breadcrumb.Item>
const CustomBreadcrumb = (config) =>  ({ match }) => (<><HomeOutlined />Главная</>);

export const RouteConfig = [
        {key: "start",     path: "/",                                 component: StartPage, exact: true, breadcrumb: () => <><HomeOutlined />Главная</>},
        {key: "wd-root", path:"/wd", exact: true, component: StartPage, breadcrumb: () => ("Дэшборды")},
        {key: "index",     path: "/wd/:wd",                           component: DashboardPage, breadcrumb: () => "Дэшборд"},
        {key: "explore",   path: "/explore/:wd",                      component: ExplorePage },
        {key: "admin",     path: "/admin",                       component: AdminPage },
        {key: "report",    path: "/report/:reportid",            component: ReportsPage },
        {key: "system",    path: "/admin/system",                component: SystemPage},
        {key: "routing",   path: "/admin/routing",               component: RoutingPage},
        {key: "users",     path: "/admin/users/:cmd?",                 component: UserEditorPage},
        {key: "trigger",   path: "/admin/triggers",              component: TriggerEditorPage},
        {key: "roles",     path: "/admin/roles",                 component: RoleEditorPage},
        {key: "flk",       path: "/admin/flk",                     component: FlkPage},
        {key: "admin-wd",  path: "/admin/wd/:cmd?",                     component: WdAdminPage},
        {key: "menu",      path: "/menu/:name",                  component: CardsPage},
        {key: "nsis", path: "/nsi", exact: true, component: NsisPage},
        {key: 'nsi', path: "/nsi/:nsi", component: NsiPage},
        {key: 'models', path: "/models",  exact: true, component: StartPage,  breadcrumb: () => <>Модели</>},
        {key: "demo", path: "/models/:modelName", component: DemoPage,
         breadcrumb: ({match}) => <>{modelName(match.params.modelName) || "Модель"}</>}
    ]

export const hideHeader = (location) => (location.pathname.indexOf('/sl') == 0)

export const MainRouter = () => (<>
    {RouteConfig.map(route => <Route key={route.key} path={route.path} component={route.component} exact={route.exact}
    />)}
</>)

export const useRoutes = isAuthenticated => {
        if (isAuthenticated) {
                return <MainRouter/>
        } else
                return <LoginPage/>
}